module.exports = __webpack_public_path__ + "static/media/gbyte.e58a6b87.svg";